import React from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { Link, withRouter } from "react-router-dom"
import { updateAccount, logIn } from "@api/account"
import GoogleIcon from "@src/media/icons/google_icon.png"
import { GLOBALS } from "@src/config"
import queryString from "query-string"
import Button from "../../../components/button"

const InternalLogin = ({ account, updateAccount, logIn, location }) => {
  const search = window.location.search.replace("logout", "")
  const param = queryString.parse(search).redirect
  const redirect = param ? `?redirect=${param}` : ""

  return (
    <div>
      <div className=''>
        <div className='center' style={{ fontSize: '20px', fontWeight: 'bold' }}>Log In</div>
        <p className='mb3 center'>
          Welcome back! Please enter your details.
        </p>
      </div>
      <form>
        <label className='cs-label' htmlFor={`__input-email`} style={{ color: 'black', fontWeight: 600 }}>Email</label>
        <input
          autoFocus={true}
          value={account.email}
          data-test-id={`account-email-input`}
          className={`cs-input col-12 ${account.validation_errors.includes('email') ? "error" : ""}`}
          type={'text'}
          id={`__input-email`}
          onChange={event => updateAccount({ email: event.target.value })} />
        {account.validation_errors.includes('email') && (
          <small
            style={{
              marginTop: '0.3em'
            }}
            data-test-id={`account-email-error-text`}
            className='block red'>
            Valid email is required.
          </small>
        )}
        <label className='cs-label mt2' htmlFor={`__input-password`} style={{ color: 'black', fontWeight: 600 }}>Password</label>
        <input
          value={account.password}
          data-test-id={`account-password-input`}
          className={`cs-input col-12 ${account.validation_errors.includes('password') ? "error" : ""}`}
          type={'password'}
          id={`__input-password`}
          onChange={event => updateAccount({ password: event.target.value })} />
        {account.validation_errors.includes('password') && (
          <small
            style={{
              marginTop: '0.3em'
            }}
            data-test-id={`account-password-error-text`}
            className='block red'>
            Password is required.
          </small>
        )}
        <div className='flex flex-auto mb2'>
          <Link
            to={{
              pathname: "/forgot",
              search: location.search
            }}
            data-test-id='account-forgot-password-link'
            className='link pointer'
            style={{ color: '#1b6aff', fontSize: '12px' }}>
            {account.error_code === "blocked_device" ? "Reset Password" : "Forgot Password?"}
          </Link>
        </div>
        {account.error_message && (
          <small data-test-id='account-error-text' className='red block mt1 mb2'>
            {account.error_message}
          </small>
        )}
        <Button
          type='submit'
          tabIndex='1'
          data-test-id='account-submit-btn'
          onClick={logIn}
          disabled={account.status === "PENDING" || !account.email || !account.password}
          className={`cs-button ${account.status.toLowerCase()} col-12`}>
          Log in
        </Button>
      </form>
      <div className='flex items-center my3'>
        <div style={{ borderBottom: '1px solid #e6e6e6', width: '100%' }}/>
        <div className='nowrap px2' style={{ fontWeight: 200 }}>
          Or continue with
        </div>
        <div style={{ borderBottom: '1px solid #e6e6e6', width: '100%' }}/>
      </div>
      <a href={GLOBALS.SOCIAL_AUTH_URL + redirect}>
        <Button
          id='cinesend-login-button'
          className='cs-button white col-12 flex items-center justify-center'
          style={{ background: 'white' }}
          tabIndex='2'
          onClick={e => {
            e.preventDefault()
            window.location = GLOBALS.SOCIAL_AUTH_URL + redirect
          }}>
          <div className='inline-flex items-center'>
            <img
              className='cs-img'
              src={GoogleIcon}
              alt='Sign in with Google'
              style={{
                width: '28px',
                height: '28px'
              }}/>
            <div className='pl1 flex items-center'>
              Google
            </div>
          </div>
        </Button>
      </a>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  account: state.account
})

const mapDispatchToProps = dispatch => ({
  updateAccount: bindActionCreators(updateAccount, dispatch),
  logIn: bindActionCreators(logIn, dispatch)
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InternalLogin))